<script lang="ts">
  import { t } from '$core/i18n';
  import {
    SHORTCUTS,
    DEFAULT_SHORTCUTS,
    formatKeyLabel,
    type ShortcutMap
  } from '$features/session';
  import { Modal } from '$ui/primitives/Modal';
  import { Button } from '$ui/primitives/Button';
  import { Kbd } from '$ui/primitives/Kbd';

  let {
    shortcuts,
    onClose
  }: {
    shortcuts?: ShortcutMap;
    onClose: () => void;
  } = $props();

  const map = $derived(shortcuts ?? DEFAULT_SHORTCUTS);
  let open = $state(true);
</script>

<Modal
  bind:open
  title={t('shortcuts.title')}
  size="md"
  onclose={onClose}
>
  <div class="body">
    <p class="intro">{t('shortcuts.intro')}</p>
    <ul class="list" role="list">
      {#each SHORTCUTS as spec (spec.action)}
        <li class="row">
          <Kbd>{formatKeyLabel(map[spec.action] ?? '')}</Kbd>
          <span class="label">{t(spec.labelKey)}</span>
        </li>
      {/each}
    </ul>
    <p class="hint">{t('shortcuts.hint')}</p>
  </div>

  {#snippet footer()}
    <Button variant="filled" onclick={onClose}>{t('shortcuts.close')}</Button>
  {/snippet}
</Modal>

<style>
  .body {
    display: flex;
    flex-direction: column;
    gap: var(--space-4);
  }

  .intro {
    margin: 0;
    font-size: var(--text-sm);
    color: var(--color-text-secondary);
  }

  .list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: var(--space-2);
    border: var(--border-width) solid var(--color-border);
    border-radius: var(--radius-md);
    padding: var(--space-3);
    background: var(--color-surface-sunken);
  }

  .row {
    display: grid;
    grid-template-columns: 88px 1fr;
    align-items: center;
    gap: var(--space-3);
    padding: var(--space-2) var(--space-2);
    border-radius: var(--radius-sm);
    transition: background var(--dur-fast) var(--ease-out);
  }

  .row:hover {
    background: var(--color-surface-hover);
  }

  .label {
    font-size: var(--text-sm);
    color: var(--color-text-primary);
  }

  .hint {
    margin: 0;
    font-size: var(--text-caption);
    color: var(--color-text-muted);
    line-height: 1.5;
  }
</style>